import { render, staticRenderFns } from "./DropdownActionsTicket.vue?vue&type=template&id=6d20e3f1&scoped=true&"
import script from "./DropdownActionsTicket.vue?vue&type=script&lang=js&"
export * from "./DropdownActionsTicket.vue?vue&type=script&lang=js&"
import style0 from "./DropdownActionsTicket.vue?vue&type=style&index=0&id=6d20e3f1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20e3f1",
  null
  
)

export default component.exports